export default class User {
  constructor(firstname, lastname, phone, email, password, accountNo, bankName) {
    this.firstname = firstname;
    this.lastname = lastname;
    this.phone = phone;
    this.email = email;
    this.password = password;
    this.account_no = accountNo;
    this.bank_name = bankName;
  }
}
